import { hotfundConstants } from '../_constants/hotfund.constants';

export const updateHotfundQueries = (queries) => ({
  type: hotfundConstants.UPDATE_HOTFUND_QUERIES,
  payload: queries
});

export const updateHotfundTableColumns = (columns) => ({
  type: hotfundConstants.UPDATE_HOTFUND_TABLE_COLUMNS,
  payload: columns
});

export const fetchHotfundStart = (data) => ({
  type: hotfundConstants.FETCH_HOTFUND_START,
  payload: data
});

export const fetchHotfundSuccess = (data) => ({
  type: hotfundConstants.FETCH_HOTFUND_SUCCESS,
  payload: data
});

export const fetchHotfundFailure = (errorMessage) => ({
  type: hotfundConstants.FETCH_HOTFUND_FAILURE,
  payload: errorMessage
});
